import Color from '@tiptap/extension-color';
import Link from '@tiptap/extension-link';
import TextAlign from '@tiptap/extension-text-align';
import TextStyle from '@tiptap/extension-text-style';
import Underline from '@tiptap/extension-underline';
import StarterKit from '@tiptap/starter-kit';
import { SurveyColorStyle } from './menu/buttons/SurveyColorStyle';

export const RichTextBaseExtensions = [
  StarterKit,
  Underline,
  SurveyColorStyle,
  TextStyle,
  Color,
  Link.configure({
    openOnClick: false,
  }),
  TextAlign.configure({
    types: ['heading', 'paragraph'],
  }),
];
